import { DateTime } from "luxon";
import { ReactElement } from "react";
import styles from "./TijdlijnSchaal.module.css";

const LabelType = {
  HOURS: styles["tijdlijn-grid-tick"] + " " + styles[`tijdlijn-grid-label-hours`],
  TENS: styles["tijdlijn-grid-tick"] + " " + styles[`tijdlijn-grid-label-tens`],
  MINUTES: styles["tijdlijn-grid-tick"] + " " + styles[`tijdlijn-grid-label-minutes`],
};

interface ITijdlijnSchaalMinuten {
  start: DateTime;
  eind: DateTime;
  scale: number;
}

export const TijdlijnSchaalMinuten = function TijdlijnSchaalMinuten({
  start,
  eind,
  scale,
}: Readonly<ITijdlijnSchaalMinuten>) {
  const minutes: ReactElement[] = [];

  const zoomDefault = 12;
  const zoomMin = 8;

  const tijdlijnLengteMinuten = (eind.toUnixInteger() - start.toUnixInteger()) / 60;

  const tickmarks5MinuteCutoff = (zoomDefault + zoomMin) / 2;

  for (let minuteNumber = 0; minuteNumber < tijdlijnLengteMinuten; minuteNumber += 1) {
    if ((start.minute + minuteNumber) % 2 !== 0) {
      continue; // we don't render odd minutes. But we do loop over them just in case the timeline starts on an odd minute which means
      // we never render the whole hour text because that would be on an even number which we don't render.
    }

    const tijdLijnCurrentTime = start.plus({ minutes: minuteNumber });

    let content: ReactElement | null = null;
    let labelType: string = LabelType.MINUTES;

    if (tijdLijnCurrentTime.minute === 0) {
      content = (
        <span className={styles["tijdlijn-grid-label"]}>
          <span className={styles["tijdlijn-grid-label-date-text"]}>
            {tijdLijnCurrentTime.toFormat("EEE d MMMM")}
          </span>
          <br />
          {tijdLijnCurrentTime.toFormat("HH:mm")}
        </span>
      );
      labelType = LabelType.HOURS;
    } else if (
      minuteNumber !== 0 &&
      tijdLijnCurrentTime.minute % (scale < tickmarks5MinuteCutoff ? 10 : 5) === 0
    ) {
      labelType = tijdLijnCurrentTime.minute % 10 === 0 ? LabelType.TENS : LabelType.MINUTES;

      content = (
        <span className={styles["tijdlijn-grid-label-minutes-text"]}>
          {tijdLijnCurrentTime.toFormat("HH:mm")}
        </span>
      );
    }

    minutes.push(
      <div key={minuteNumber} className={labelType}>
        {content}
      </div>,
    );
  }

  return minutes;
};
